var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: _vm.id, "data-backdrop": "static" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "text-right" }, [
            _c("div", { staticClass: "cancel", on: { click: _vm.reset } }, [
              _c("img", {
                staticClass: "small",
                attrs: {
                  src: require("../../../public/static/images/icons/close_icon.svg"),
                  alt: "close-icon",
                },
              }),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _vm._m(0),
              !_vm.isGlobalSearch && !_vm.isCountryNotSubscribed
                ? [
                    _c("p", { staticClass: "title" }, [
                      _vm._v(
                        " The market is not available as you are not subscribed to this country "
                      ),
                    ]),
                    _vm._m(1),
                  ]
                : [
                    _vm.isGlobalSearch
                      ? _c("p", { staticClass: "title" }, [
                          _vm._v(
                            " This service is not available as you are not subscribed "
                          ),
                        ])
                      : _vm.isCountryNotSubscribed
                      ? _c("p", { staticClass: "title" }, [
                          _vm._v("This country is not selected."),
                        ])
                      : _vm._e(),
                    _vm.isGlobalSearch
                      ? _c("p", { staticClass: "desc" }, [
                          _vm._v(" Please visit "),
                          _c(
                            "a",
                            {
                              staticClass: "link",
                              attrs: {
                                href: `/layout/market-place/service/${_vm.selectedServiceId}`,
                              },
                            },
                            [_vm._v("Marketplace")]
                          ),
                          _vm._v(" and subscribe to this service. "),
                        ])
                      : _vm.isCountryNotSubscribed
                      ? _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            " Regulatory updates are displayed based on countries selected under "
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "link cursor-pointer",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.openRegWatchInAccountSettings.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("Account Settings")]
                          ),
                          _vm._v(
                            " See all countries or customize based on your market interest. "
                          ),
                        ])
                      : _vm._e(),
                  ],
            ],
            2
          ),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "text-center" }, [
              _c(
                "button",
                {
                  staticClass: "ok-btn emergo-green-button",
                  on: { click: _vm.reset },
                },
                [_vm._v("OK")]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("img", {
        attrs: {
          src: require("../../../public/static/images/icons/expiring_soon.svg"),
          alt: "expiringsoon-icon",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "desc" }, [
      _vm._v(" Please visit "),
      _c(
        "a",
        {
          staticClass: "link",
          attrs: { href: "/layout/market-place/service/2" },
        },
        [_vm._v("Marketplace")]
      ),
      _vm._v(
        " and subscribe to this country as other markets are part of Regulatory Intelligence subscription in Marketplace. "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }